<template>
    <div class="md-card">
        <h6 class="md-card-header" style="text-align: left">
            {{ $t('shift.main.results') }}
            <i class="fas fa-times" style="float: right"
               @click="closeShiftDesignDetails"></i>
        </h6>
        <div class="md-card-body">
            <datatablesimple :state="planningTableState"></datatablesimple>
            <div class="md-card-select">
                <div v-if="isPolling">
                    <i class="fas fa-spinner"></i>
                </div>
                <div class="full">
                    <div class="half">
                        <labelc type="header" class="label" :text="'Ziel - Schichtgruppe:'" />
                    </div>
                    <div class="half">
                        <dropdownsearch class="dropdown" :state="shiftGroupState"
                                        @item-selected="updateSelected"></dropdownsearch>
                    </div>
                </div>
                <div class="full">
                    <div class="half">
                        <labelc type="header" class="label" :text="'Nur aktuelle Woche:'" />
                    </div>
                    <div class="half">
                        <checkbox :data="currentWeekOnly" :value="currentWeekOnly.value" @Update="ToggleCheckbox" />
                    </div>
                </div>
                <div class="full col-1 center">
                    <buttonc type="rectangle green" label="Akzeptieren" @click="acceptShiftDesign"
                             style="width: 100px; margin-bottom: 5px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import dropdownsearch from "@/components/uicomponents/dropdownsearch.vue";

export default {
    name: "shiftDesignDetails",
    components: {dropdownsearch},
    props: {
        shiftGroupState: Object,
        spotMap: Object,
        shiftDesigns: null,
        selected: null,
    },
    data() {
        return {
            currentWeekOnly: {label: 'Nur aktuelle Woche', value: true},
            showShiftDesignDetails: true,
            selectedDesign: null,
            timerId: null,
            timerInterval: 60*1000
        }
    },
    mounted() {
        let view = this;
        this.selectedDesign = this.selected;
        if (this.isPolling) {
            this.startTimer();
        }

    },
    beforeDestroy() {
        this.clearTimer();
        this.showShiftDesignDetails = false
    },
    watch: {
        selected(newVal, oldVal) {
            console.log('selected changed')
            this.selectedDesign = newVal;
            if (newVal && this.showShiftDesignDetails) {
                console.log('start poll')
                this.startTimer();
            } else {
                this.clearTimer();
            }
        }
    },
    computed: {
        selectedShiftDesign() {
            return this.selectedDesign;
        },
        planningTableState() {
            let view = this;

            if (view.shiftDesigns === null || view.selectedShiftDesign === null) {
                return null;
            }

            let state = {};
            state.headerMap = [];

            let columns = {};
            columns.spotName = this.$tc('shift.main.position');
            columns.label = this.$t('shift.main.time');

            let data = [];
                try {
                    view.selectedShiftDesign.data.map(du => {
                        let weekDay = view.$helpers.getMomentFromStringTZ(du.result.solution.requirements[0].startDateTime, 'YYYY-MM-DDTHH:mm:ss');
                        return {
                            weekDay: weekDay, spotName: view.spotMap[du.slotId].name,
                            label: view.spotMap[du.slotId].name + " - " + weekDay.format("DD.MM.YYYY dddd") +
                                " - " + (du.state > 2 ? this.$t('global.notifications.error') : (du.state > 1 ? this.$t('workBalance.payroll.finished') : 'In Bearbeitung'))
                        }
                    }).sort((a, b) => {
                        if (a.spotName !== b.spotName) {
                            return a.spotName.localeCompare(b.spotName);
                        } else {
                            return a.weekDay - b.weekDay
                        }
                    }).forEach(r => {
                        data.push({spotName: r.spotName, label: r.label});
                    });
                } catch (e) {
                    console.log(e);
                }
            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabel(state.headerMap, 'spotName')
            view.$helpers.buildHeaderMapLabel(state.headerMap, 'label')

            let entries = Object.entries(state.headerMap);

            let nameColumns = ['spotName'];
            let nameColumnWidth = 30;
            let mainColumns = ['label'];
            let mainColumnWidth = 70;

            for (let x in entries) {
                if (nameColumns.includes(entries[x][0])) {
                    entries[x][1].width = nameColumnWidth + '%';
                } else if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                }

                entries[x][1].key = entries[x][0];

            }

            state.headerStyles = {fontSize: '12px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        },
        isPolling() {
            console.log(this.selectedShiftDesign)
            return this.showShiftDesignDetails && this.selected != null && (this.selectedShiftDesign === null ||
                Object.values(this.selectedShiftDesign.data).filter(du => du.state < 2).length > 0);
        },
    },
    methods: {
        clearTimer(){
            if(this.timerId != null){
                clearTimeout(this.timerId);
            }
        },
        startTimer(){
            this.clearTimer();
            this.timerId = setTimeout(this.poll, this.timerInterval);
        },
        poll() {
            let view = this;
            if (this.isPolling) {
                console.log('poll')
                this.updateShiftDesign(this.selected.id)
                .then(() => {
                    view.startTimer();
                });
            } else {
                console.log('stop poll')
                this.clearTimer();
            }
        },
        closeShiftDesignDetails() {
            this.clearTimer();
            this.showShiftDesignDetails = false;
            this.$emit("close-shift-design-details");
        },
        acceptShiftDesign() {
            this.$emit("accept-shift-design", this.selectedShiftDesign.data, this.shiftGroupState.selectedItem.value, this.currentWeekOnly.value);
        },
        updateSelected(item) {
            this.shiftGroupState.selectedItem = item;
        },
        ToggleCheckbox($event, value, entry){
            entry.value = value;
        },
        updateShiftDesign(shiftDesignId) {
            let view = this;
            return new Promise((resolve, reject) => {
                view.loadShiftDesign(shiftDesignId)
                .then(response => {
                    view.selectedDesign = response.data;
                    resolve();
                }).catch(e => {
                    view.$helpers.error('Fehler', 'Fehler beim Laden der Daten');
                    resolve();
                });
            });

        },
        loadShiftDesign(id){
            let view = this;
            let url = '/api/sec/shiftdesign';

            let params = {
                storeId: this.$store.state.storeId,
                id: id
            }

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': 'bearer ' + this.$store.state.jwt
                },
                url: url,
                params: params
            })
        },
    }
}

</script>

<style scoped>
.fa-spinner {
    margin-right: auto;
    margin-left: auto;
    width: 60px;
    height: 60px;
    font-size: 60px;
    color: var(--md);
    animation-name: spin;
    animation-duration: 2000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    overflow: hidden !important;
}

.md-card {
    position: absolute;
    z-index: 100;
    width: calc(50% - 18px);
    top: 55px;
    left: 50%;
    bottom: auto;
    right: auto;
}

.md-card-body {
    max-height: calc(100vh - var(--header-height) - 140px);
    scrollbar-width: none;
}

.col-1 {
    display: grid;
}

.center {
    flex-wrap: wrap;
    justify-items: center;
}

.full {
    padding-bottom: 5px;
}

.label {
    width: 9em;
    padding-bottom: 8px;
}

.dropdown {
    width: 200px;
}

.half {
    position: relative;
    float: left;
    width: 30%;
}
</style>
